import { Form } from 'antd';
import Box from 'components/Box';
import moment from 'moment';
import React from 'react';
import styled from 'styled-components';
import { StartTimes, TimeSelection, TimeSelectionRef } from './TimeDate';
import { IQuickBookingV2FormValues, IQuickBookingV2ServiceItem } from './type';
import { quickBookingServiceContentRef } from './ServiceContent';
import shopSelectors from 'services/shop/selectors';
type Props = {
  timeRef: React.RefObject<TimeSelectionRef>;
  onPickDate: (date: moment.Moment) => Promise<void>;
  forceCalculateTime?: boolean;
  isDetail?: boolean;
};
const QuickBookingTimeContent = ({ timeRef, onPickDate, forceCalculateTime, isDetail }: Props) => {
  const form = Form.useFormInstance();
  const anybody = shopSelectors.data.anybody();

  const onStartTimeChange = (startTime?: string) => {
    if (!startTime) return;
    const customerList: IQuickBookingV2FormValues['customerList'] = form.getFieldValue('customerList');
    const masterDuration: IQuickBookingV2FormValues['duration'] = form.getFieldValue('duration');
    const sameTimeBooking: boolean = form.getFieldValue('sameTimeBooking');

    const _customerListMapping = customerList.map(o => {
      let startDate = startTime || '';
      return ({
        ...o,
        services: o.services.map(s => {
          const result: IQuickBookingV2ServiceItem = ({
            ...s,
            startTime: startDate,
          });
          if (!isDetail) {
            result.anybody = true;
            result.staffId = anybody?.id || '';
            result.staffName = anybody?.nickName || '';
          }
          if (isDetail) {
            if (forceCalculateTime || masterDuration === undefined) {
              startDate = moment(startDate || '', 'hh:mm A')
                .add(s.duration, 'minutes')
                .format('hh:mm A');
            }
          } else {
            if (!sameTimeBooking && (forceCalculateTime || masterDuration === undefined)) {
              startDate = moment(startDate || '', 'hh:mm A')
                .add(s.duration, 'minutes')
                .format('hh:mm A');
            }
          }
          return result;
        })
      });
    });
    form.setFieldValue('customerList', _customerListMapping);
    if (_customerListMapping.length > 0 && _customerListMapping?.[0]?.services?.length) {
      const customer = _customerListMapping?.[0];
      quickBookingServiceContentRef.current?.onActiveService(customer.services?.[0], customer.services);
    }
  };

  return (
    <Box display='flex' flexDirection='column' style={middleContainerStyle}>
      <OverflowBox>
        <Form.Item noStyle name={'defaultStaffId'} />
        <Form.Item noStyle name={'dayOffs'} />
        <Form.Item noStyle name={'activeServiceId'} />
        <Form.Item noStyle name={'date'} rules={[{ required: true }]}>
          <TimeSelection ref={timeRef} onPickDate={onPickDate} />
        </Form.Item>
        <Form.Item noStyle name={'startTime'} rules={[{ required: true }]}>
          <StartTimes onStartTimeChange={onStartTimeChange} />
        </Form.Item>
        <Box mb='4' />
      </OverflowBox>
    </Box>
  );
};

export default QuickBookingTimeContent;

const middleContainerStyle: React.CSSProperties = {
  flex: 1,
  minWidth: 600,
  position: 'relative',
};
const OverflowBox = styled.div`
  position: absolute;
  inset: 0;
  overflow: auto;
  padding: 16px;
  &::-webkit-scrollbar {
    display: none;
  }
  -ms-overflow-style: none;
  scrollbar-width: none;
`;
